import { render } from "./PageMaintenance.vue?vue&type=template&id=2e243e33"
import script from "./PageMaintenance.vue?vue&type=script&lang=js"
export * from "./PageMaintenance.vue?vue&type=script&lang=js"

import "./PageMaintenance.vue?vue&type=style&index=0&id=2e243e33&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__